import TransactionHistory from "@domains/useCases/Reports/TransactionHistory/TransactionHistory";
import ApproximateTxnsUseCase from "@domains/useCases/Reports/TransactionHistory/IApproximateTxns";
import DownloadExcelReport from "@domains/useCases/Reports/common/downloadReport/downloadExcelReport";
import DownloadPDFReport from "@domains/useCases/Reports/common/downloadReport/downloadPdfReport";
import EmailReport from "@domains/useCases/Reports/common/emailReport/emailReport";
import { TransactionHistoryCommonUseCase, SearchUseCase, FilterUseCase, SortUseCase, } from "@domains/useCases/Reports/TransactionHistory/TransactionHistoryCommonUseCase";
export default (repositories) => {
    return {
        transactionHistory: new TransactionHistory(repositories.transactionHistory),
        sendEmailReports: new EmailReport(repositories.downloadRepo),
        downloadPDFReports: new DownloadPDFReport(repositories.downloadRepo),
        downloadExcelReports: new DownloadExcelReport(repositories.downloadRepo),
        TransactionHistoryCommonUseCase: new TransactionHistoryCommonUseCase(new SearchUseCase(), new FilterUseCase(), new SortUseCase()),
        approximateTxns: new ApproximateTxnsUseCase(repositories.transactionHistory),
    };
};
